import { Button, Grid } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo } from 'react'
import { metodoPrograma } from '../../../components/api'
import DateField from '../../../components/DateField/DateField'
import dayjs from 'dayjs'
import { setError } from '../../../components/alerts'
import * as Yup from 'yup'

const validationFormik = Yup.object({
  dsEquipamento: Yup.string().required('Campo Obrigatório!'),
})

const retornaEquipamento = (u = []) => ({
  idEquipamento: u?.[0] || undefined,
  dsEquipamento: u?.[1] || undefined,
  cdPatrimonio: u?.[2] || undefined,
  dtCompra: u?.[3] ? dayjs(u?.[3]) : null,
  dsNumeroSerie: u?.[4] || undefined,
  dsFabricante: u?.[5] || undefined,
  dsModelo: u?.[6] || undefined,
  dsObservacao: u?.[7] || undefined,
  dtGarantia: u?.[9] ? dayjs(u?.[9]) : null,
})
const Edicao = ({ dados, voltar }) => {
  const salva = async (values) => {
    const payload = {
      ...values,
      dtCompra: values?.dtCompra
        ? dayjs(values.dtCompra).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
      dtGarantia: values?.dtGarantia
        ? dayjs(values.dtGarantia).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
    }

    const res = await metodoPrograma('salva', payload)
    if (res.status) voltar()
    else setError(res.dsErro)
  }

  return (
    <Formik
      initialValues={retornaEquipamento(dados)}
      validationSchema={validationFormik}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm, values, setFieldValue }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dsEquipamento"
                label="Equipamento"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>

            <Grid item xs={3}>
              <Field
                component={TextField}
                name="cdPatrimonio"
                label="Patrimonio"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>

            <Grid item xs={3}>
              <DateField
                label="Dt. Compra"
                fullWidth
                value={values?.dtCompra}
                onChange={(v) => setFieldValue('dtCompra', v)}
              />
            </Grid>

            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dsNumeroSerie"
                label="Nr. Série"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>

            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dsFabricante"
                label="Fabricante"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>

            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dsModelo"
                label="Modelo"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>

            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dsObservacao"
                label="Observações"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>

            <Grid item xs={3}>
              <DateField
                label="Dt. Garantia"
                fullWidth
                value={values?.dtGarantia}
                onChange={(v) => setFieldValue('dtGarantia', v)}
              />
            </Grid>

            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
